<!--
 * @Author: wangliang wangliang@wiz.top
 * @Date: 2023-10-08 9:42:41
 * @LastEditors: wangliang wangliang@wiz.top
 * @LastEditTime: 2023-10-08 9:42:41
-->
<template>
  <div class="h-full relative">
    <el-card class="h-full">
      <div class="h-40px">
        <el-input
          size="small"
          clearable
          placeholder="请输入楼层名称或编码"
          class="!w-200px mr-10px"
          v-model="searchData.filter"
        />
        <el-select
          v-model="searchData.sceneId"
          size="small"
          placeholder="请选择场景"
          class="!w-200px mr-10px"
          clearable
        >
          <el-option
            v-for="item in sceneList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button :disabled="!$hasAccess('read')" size="small" type="primary" @click="handleSearch"
          >搜索</el-button
        >
        <el-button :disabled="!$hasAccess('read')" size="small" @click="resetForm()"
          >重置</el-button
        >
        <el-button
          :disabled="!$hasAccess('create')"
          size="small"
          type="primary"
          @click="openDrawBuild({})"
          >新增</el-button
        >
        <el-button
          :disabled="!$hasAccess('delete')"
          size="small"
          type="danger"
          @click="deleteList()"
          >删除</el-button
        >
      </div>
      <el-table
        ref="tableRef"
        v-loading="tableLoading"
        @selection-change="handleSelectionChange"
        :height="tableHeight"
        :data="dataList"
        class="mt-20px"
        border
        stripe
        row-key="id"
      >
        <el-table-column type="selection" width="50" reserve-selection></el-table-column>
        <el-table-column
          label="序号"
          type="index"
          width="60"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="楼层名称" prop="name" show-overflow-tooltip></el-table-column>
        <el-table-column label="楼层编码" prop="code" show-overflow-tooltip> </el-table-column>
        <el-table-column label="所属建筑" prop="buildingName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="关联剖切对象" prop="sectionName" show-overflow-tooltip>
        </el-table-column>
        <el-table-column width="200" label="操作" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button
              :disabled="!$hasAccess('read')"
              size="mini"
              @click="
                openDrawBuild({
                  id: scope.row.id,
                  sceneId: scope.row.sceneId,
                  operateType: 'read',
                })
              "
              >详情</el-button
            >
            <el-button
              :disabled="!$hasAccess('update')"
              size="mini"
              @click="
                openDrawBuild({
                  id: scope.row.id,
                  sceneId: scope.row.sceneId,
                  operateType: 'update',
                })
              "
              >编辑</el-button
            >
            <el-button
              :disabled="!$hasAccess('delete')"
              size="mini"
              @click="removeTableData(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="float-right mt-20px"
        background
        @size-change="handleSearch()"
        @current-change="getListData()"
        :current-page.sync="pageConfig.SkipCount"
        :page-size.sync="pageConfig.MaxResultCount"
        layout="total, sizes ,prev, pager, next"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="totalCount"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { FloorApi } from '@wiz-api/personnel-position'
import { ModelSceneApi } from '@wiz-api/scene-management'
import {
  cloneDeep,
  isNil,
  assign,
  clone,
  isEmpty,
  fromPairs,
  isObject,
  join,
  map,
  toPairs,
  filter,
  get,
} from 'lodash'
// 业务请求
const floor = new FloorApi()
const modelSceneApi = new ModelSceneApi()

export default {
  name: 'floorManagement',
  components: {},
  data() {
    return {
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      }, // 分页参数
      totalCount: 0,
      searchData: {}, // 搜索字段
      sceneList: [], // 场景列表
      tableLoading: false, // 表格加载
      multipleSelect: [], // 表格选中数据
      dataList: [], // 表格数据
    }
  },
  async created() {
    // 获取场景列表
    await this.getSceneList()
    // 初始化请求列表
    this.getListData()
  },
  computed: {
    // 表格高度适配
    tableHeight() {
      return 'calc(100% - 115px)'
    },
    // 场景名称对象映射
    sceneNameReflect() {
      return fromPairs(
        map(this.sceneList, (item) => {
          return [item.id, item.name]
        })
      )
    },
    // 兼容除saas其他项目使用该模块
    basePath() {
      return get(Wiz, 'globalSettings.globalConfig.routerBase')
        ? `/${Wiz.globalSettings.globalConfig.routerBase}`
        : ''
    },
  },
  methods: {
    // 选中处理
    handleSelectionChange(val) {
      this.multipleSelect = val
    },
    // 新增区域
    openDrawBuild(routeInfo = { id: '', operateType: '' }) {
      if (!isObject(routeInfo)) {
        return
      }
      // 参数拼接
      const routeQuery = join(
        map(toPairs(routeInfo), (item) => {
          return join(item, '=')
        }),
        '&&'
      )
      this.$router.push(
        `${this.basePath}/position-backend-management/build-floor/draw-floor?${routeQuery}`
      )
    },
    // 获取数据字典列表
    async getSceneList() {
      const [err, res] = await modelSceneApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err && !isNil(res)) {
        this.sceneList = cloneDeep(res.items)
      }
    },
    // 重置搜索
    resetForm() {
      this.searchData = this.$options.data().searchData
      this.handleSearch()
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getListData()
    },
    // 获取列表数据
    async getListData() {
      this.tableLoading = true
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      const [err, res] = await floor.getList(data)
      if (!err) {
        this.dataList = map(res.items, (item) => {
          return assign(item, {
            sceneName: this.sceneNameReflect[item.sceneId] || '',
          })
        })
        this.totalCount = res.totalCount
        this.tableLoading = false
      }
    },
    // 楼栋删除
    async removeTableData(data) {
      await this.$confirm('此操作将永久删除所选数据，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
      // 待接口对接调整
      const [err, res] = await floor.callDelete(data.id)
      if (!err) {
        this.$message.success('删除成功！')
        this.multipleSelect = filter(this.multipleSelect, (item) => {
          return item.id !== data.id
        })
        this.$refs.tableRef.toggleRowSelection(data, false)
        this.getListData()
      }
    },
    // 批量删除
    async deleteList() {
      if (isEmpty(this.multipleSelect)) {
        this.$message.warning('请选择需要删除区域!')
        return
      }
      await this.$confirm('此操作将永久删除所选数据，是否继续？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      })
      const [err] = await floor.deleteMany({
        ids: map(this.multipleSelect, 'id'),
      })
      if (!err) {
        this.$refs.tableRef.clearSelection()
        this.$message.success('删除成功')
        this.getListData()
        return
      }
      this.$message.error('删除失败')
    },
    // 是否显示名称切换
    async changeShowAreaName(data, isDisplay) {
      // 兼容页面加载方式
      const params = clone(data)
      const [err, res] = await floor.update(params.id, {
        body: { ...params, isDisplay },
      })
      if (!err) {
        this.getListData()
        this.$message.success('修改成功')
      }
    },
  },
}
</script>

<style scoped lang="scss">
.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
.button-normal.el-button.el-tooltip {
  width: unset !important;
  height: unset !important;
  padding: 6px 12px !important;
}
::v-deep {
  .el-select__tags .el-tag {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-card__body {
    height: 100%;
  }
  .el-tag--empty {
    background-color: transparent;
    border-color: transparent;
    color: var(--contentTextColor);
  }
}
</style>
